/**
 * 把考試站的前端錯誤回報到伺服器 log（POST /exam/details/{id}/clientlog）。
 *
 * 為什麼需要：2026-10-18 倪筱晴聽力、張元輔閱讀整科 0 筆作答，兩位都說有作答，
 * 伺服器上卻看不出任何異常——錯誤只發生在考生的瀏覽器裡，我們看不到。
 * 有了這個，下次再發生就能在 log 裡看到是哪一行、什麼錯。
 *
 * 只回報、不影響作答：送不出去就算了，絕不丟例外。
 * 每次載入最多送 MAX_REPORTS 筆，避免某個錯誤每秒觸發一次時把 log 灌爆。
 */

const MAX_REPORTS = 20;
let sent = 0;
let currentDetailId = null;

/** App 在進入／離開某一科時設定，回報時才知道是哪一科 */
export function setClientLogDetail(examDetailId) {
  currentDetailId = examDetailId || null;
}

export function reportClientError(kind, error, where) {
  try {
    if (!currentDetailId || sent >= MAX_REPORTS) {
      return;
    }
    sent += 1;
    const message =
      error && error.message ? error.message : String(error === undefined ? "" : error);
    const stack = error && error.stack ? String(error.stack).split("\n").slice(0, 4).join(" | ") : "";
    const url = `${process.env.REACT_APP_EXAM_DETAILS}/${currentDetailId}/clientlog`;
    const body = new FormData();
    body.append("kind", String(kind).slice(0, 40));
    body.append("message", message.slice(0, 500));
    body.append("where", `${where || ""} ${stack}`.trim().slice(0, 300));
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(url, body);
    } else if (typeof fetch === "function") {
      fetch(url, { method: "POST", body, keepalive: true }).catch(() => {});
    }
  } catch (e) {
    // 回報本身失敗就算了，不能影響作答
  }
}

/** 測試用：歸零計數 */
export function resetClientLogForTest() {
  sent = 0;
  currentDetailId = null;
}
